import PropTypes from "prop-types";
import { Route, Routes } from "react-router-dom";

// homer
import Dashboard from "@/pages/DashboardV2/Dashboard";

// business
import AddBusiness from "@/pages/Business/AddBusiness";
import BusinessList from "@/pages/Business/BusinessList";
import BusinessView from "@/pages/Business/BusinessView";
import EditBusiness from "@/pages/Business/EditBusiness";

// users
import UserCreate from "@/pages/Users/UserCreate";
import UserDetails from "@/pages/Users/UserDetails";
import UserEdit from "@/pages/Users/UserEdit";
import UserList from "@/pages/Users/UserList";

// site
import AddSiteLocation from "@/pages/SiteLocations/AddSiteLocation";
import EditSiteLocation from "@/pages/SiteLocations/EditSiteLocation";
import SiteLocationView from "@/pages/SiteLocations/SiteLocationView";
import SiteLocationsList from "@/pages/SiteLocations/SiteLocationsList";

// devices
import AddDevice from "@/pages/Devices/AddDevice";
import DeviceCSVUpload from "@/pages/Devices/DeviceCSVUpload";
import DeviceData from "@/pages/Devices/DeviceData";
import DeviceDetails from "@/pages/Devices/DeviceDetails";
import DeviceList from "@/pages/Devices/DeviceList";
import DeviceTypes from "@/pages/Devices/DeviceTypes";
import EditDevice from "@/pages/Devices/EditDevice";

// settings
import ActivityLog from "@/pages/Settings/ActivityLog";
import ElectricityTariff from "@/pages/Settings/ElectricityTariff";
import WaterTariff from "@/pages/Settings/WaterTariff";
import ManageFormulas from "@/pages/Settings/Formula/ManageFormulas";
import Parameters from "@/pages/Settings/Parameters/Parameters";
import Settings from "@/pages/Settings/Settings";

// analysis
import BillingReport from "@/pages/AnalysisReporting/BillingReport";
import WaterReport from "@/pages/AnalysisReporting/WaterReport";
import DataAnalysis from "@/pages/AnalysisReporting/DataAnalysis";

// notification
import AlarmHistory from "@/pages/Notifications/AlarmHistory";
import AlarmSummary from "@/pages/Notifications/AlarmSummary";
import AlarmView from "@/pages/Notifications/AlarmView";
import CreateAlarm from "@/pages/Notifications/CreateAlarm";
import EditAlarm from "@/pages/Notifications/EditAlarm";
import RecipientList from "@/pages/Notifications/RecipientList";

// dashboard
import AssignDashboard from "@/pages/Dashboard/AssignDashboard";
import DashboardList from "@/pages/Dashboard/DashboardList";
import DashboardListView from "@/pages/Dashboard/DashboardListView";
import EditDashboard from "@/pages/DashboardV2/EditDashboard";
import LiveDashboardEditor from "@/pages/DashboardV2/LiveDashboardEditor";
import DefaultDashboardList from "@/pages/Dashboard/DefaultDashboardList";

// report
import CustomReportList from "@/pages/CustomReport/CustomReportList";
import EditReport from "@/pages/CustomReport/EditReport";
import ViewReport from "@/pages/CustomReport/ViewReport";

// custom report template
import AssignCustomReportTemplate from "@/pages/customReportTemplate/AssignCustomReportTemplate";
import CustomReportTemplate from "@/pages/customReportTemplate/CustomReportTemplate";
import CustomReportTemplateView from "@/pages/customReportTemplate/CustomReportTemplateView";
import EditReportTemplate from "@/pages/customReportTemplate/EditReportTemplate";
import ReportTemplateList from "@/pages/customReportTemplate/ReportTemplateList";

// subscription
import AssigPlan from "@/pages/Subscription/AssigPlan";
import CreateOrEditPlan from "@/pages/Subscription/CreateOrEditPlan";
import MySubscriptionSummary from "@/pages/Subscription/MySubscriptionSummary";
import Planlist from "@/pages/Subscription/Planlist";
import SubscriptionSummary from "@/pages/Subscription/SubscriptionSummary";
import ViewAssignPlan from "@/pages/Subscription/ViewAssignPlan";
import ViewAssingedSubscription from "@/pages/Subscription/ViewAssingedSubscription";
import ViewPlan from "@/pages/Subscription/ViewPlan";

// profile
import EditProfile from "@/pages/Profile/EditProfile";
import Profile from "@/pages/Profile/Profile";
import SupportRequest from "@/pages/Support/SupportRequest";
import SupportInbox from "@/pages/Support/SupportInbox";

// others

// // import DashboardTwo from '@/pages/Dashboard/DashboardTwo';
// import DeviceInformation from "@/pages/Dashboard/DeviceInformation";
// import DashboardSettings from "@/pages/Settings/DashboardSettings";
// import BuildingBackgroundTypes from "@/pages/Settings/BuildingTypes/BuildingBackgroundTypes";
// import Dial from "@/pages/Dial/Dial";
// import DialView from "@/pages/Dial/DialView";
// import CreateDial from "@/pages/Dial/CreateDial";
// import EditDial from "@/pages/Dial/EditDial";

export default function MyRoutes({ handle }) {
  return (
    <Routes>
      {/* Dashboard Information Route */}
      <Route path="/" element={<Dashboard handle={handle} />} />
      <Route path="/dashboard-list/:id" element={<DashboardListView />} />
      <Route path="/edit-dashboard/:id" element={<EditDashboard />} />
      <Route path="/dashboard-list" element={<DashboardList />} />
      <Route path="/assign-dashboard" element={<AssignDashboard />} />
      <Route path="/default-dashboard-list" element={<DefaultDashboardList />} />
      <Route path="/live-dashboard/:id" element={<LiveDashboardEditor />} />

  {/* Subcription Related Routes */ }
      <Route path="/create-plan" element={<CreateOrEditPlan />} />
      <Route path="/plan-list" element={<Planlist />} />
      <Route path="/view-plan/:planId" element={<ViewPlan />} />
      <Route path="/edit-plan/:planId" element={<CreateOrEditPlan />} />
      <Route path="/assign-plan" element={<AssigPlan />} />
      <Route path="/view-assign-plan/:planId" element={<ViewAssignPlan />} />
      <Route path="/subscription-summary" element={<SubscriptionSummary />} />
      <Route path="/my-subscription" element={<MySubscriptionSummary />} />
      <Route path="/subscription/details/:planId" element={<ViewAssingedSubscription />} />

  {/* business */ }
      <Route path="business" element={<BusinessList />} />
      <Route path="business/create" element={<AddBusiness />} />
      <Route path="business/details/:businessId" element={<BusinessView />} />
      <Route path="business/edit/:businessId" element={<EditBusiness />} />
  {/* users route */ }
      <Route path="/users" element={<UserList />} />
      <Route path="/users/create" element={<UserCreate />} />
      <Route path="/users/edit/:userId" element={<UserEdit />} />
      <Route path="/users/details/:userId" element={<UserDetails />} />

  {/* site */ }
      <Route path="site-locations" element={<SiteLocationsList />} />
      <Route path="site-locations/create" element={<AddSiteLocation />} />
      <Route path="site-locations/details/:siteLocationId" element={<SiteLocationView />} />
      <Route path="site-locations/edit/:siteLocationId" element={<EditSiteLocation />} />

  {/* device */ }
      <Route path="devices" element={<DeviceList />} />
      <Route path="devices/details/:deviceId" element={<DeviceDetails />} />
      <Route path="device-types" element={<DeviceTypes />} />
      <Route path="add-devices" element={<AddDevice />} />
      <Route path="devices/edit/:deviceId" element={<EditDevice />} />
      <Route path="devices/data/:deviceId" element={<DeviceData />} />
      <Route path="device-csv-upload" element={<DeviceCSVUpload />} />

  {/* Settings related Routes */ }
      <Route path="/settings" element={<Settings />} />
      <Route path="/electricity-tariff" element={<ElectricityTariff />} />
      <Route path="/water-tariff" element={<WaterTariff />} />
      <Route path="/parameters" element={<Parameters />} />
      <Route path="/formulas" element={<ManageFormulas />} />
      <Route path="/activity-log" element={<ActivityLog />} />

  {/* Analysis &Reporting related routes */ }
      <Route path="/data-analysis" element={<DataAnalysis />} />
      <Route path="/billing-report" element={<BillingReport />} />
      <Route path="/water-report" element={<WaterReport />} />

  {/* Notification related routes */ }
      <Route path="/alarm-summary" element={<AlarmSummary />} />
      <Route path="/alarm-history" element={<AlarmHistory />} />
      <Route path="/create-alarm" element={<CreateAlarm />} />
      <Route path="/recipient-list" element={<RecipientList />} />
      <Route path="/alarm-view/:alarmId" element={<AlarmView />} />
      <Route path="/edit-alarm/:alarmId" element={<EditAlarm />} />

  {/* CustomReport template */ }
      <Route path="/edit-report-template/:id" element={<EditReportTemplate />} />
      <Route path="/report-template-list" element={<ReportTemplateList />} />
      <Route path="/report-template/:id" element={<CustomReportTemplateView />} />
      <Route path="/assign-report-template" element={<AssignCustomReportTemplate />} />

  {/* custom report */ }
      <Route path="/generate-report" element={<CustomReportTemplate />} />
      <Route path="/edit-report/:id" element={<EditReport />} />
      <Route path="/report-list" element={<CustomReportList />} />
      <Route path="/report-list/:id" element={<ViewReport />} />

      <Route path="/profile" element={<Profile />} />
      <Route path="/edit-profile" element={<EditProfile />} />

  {/* support */ }
      <Route path="/support-request" element={<SupportRequest />} />
      <Route path="/support-inbox" element={<SupportInbox />} />

  {/* dial */ }
  {/* <Route path="/dial" element={<Dial />} />
      <Route path="/dial/create" element={<CreateDial />} />
      <Route path="/dial/edit/:id" element={<EditDial />} />
      <Route path="/dial/:id" element={<DialView />} /> */}

  {/* not foudn page */ }
  <Route path="*" element={<> </>} />
    </Routes >
  );
}

MyRoutes.propTypes = {
  handle: PropTypes.shape({
    enter: PropTypes.func.isRequired,
    exit: PropTypes.func.isRequired,
    active: PropTypes.bool,
  }).isRequired,
};
